import gql from "graphql-tag";

import {gqlOp, type GqlOperation} from "@khan/data-gql-core";

import type {configurableInputsForActivityType} from "./__graphql-types__/index.ts";

export const USE_CONFIGURABLE_INPUTS: GqlOperation<
    configurableInputsForActivityType["response"],
    configurableInputsForActivityType["variables"]
> = gqlOp(gql`
    query configurableInputsForActivity($contentID: String!) {
        aiGuideActivityById(id: $contentID) {
            id
            configurableInputs
        }
    }
`);
